module.exports = __webpack_public_path__ + "img/wine-glass-empty.fb81893c.svg";